export const firstPageNmb = 1;
export const firstRequestSize = 6;
export const searchListPageSize = 15;
export const searchHeadingId = 'searchHeading';
